import logo from 'assets/img/footer_logo.png';
import FixedPlugin from 'components/FixedPlugin/FixedPlugin.jsx';
import Footer from 'components/Footer/Footer.jsx';
import GuestNavbar from 'components/Navbars/GuestNavbar.jsx';
import SidebarWrapper from 'components/Sidebar/SidebarWrapper';
import getGuestRoutes from 'guestRoutes.js';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
// javascript plugin used to create scrollbars on windows

// core components

const EXCLUDED_ROUTES = ['SAST_Add_Repos'];

class Guest extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      backgroundColor: 'blue',
      currentCompanyId: null,
      sidebarOpened:
        document.documentElement.className.indexOf('nav-open') !== -1,
      routes: getGuestRoutes(),
      releaseNotesLastVisitedDate: localStorage.getItem(
        'releaseNoteLastVisitedDate',
      ),
      // we only need to update the routes once per session
      routesUpdatedOnce: false,
    };
  }
  componentDidMount() {
    if (navigator.platform.indexOf('Win') > -1) {
    }

    if (!this.state.currentCompanyId) {
      const currentCompanyId =
        localStorage.getItem('currentCompanyId') > 0
          ? parseInt(localStorage.getItem('currentCompanyId'))
          : undefined;
      this.setState({ currentCompanyId: currentCompanyId });
    }
  }
  componentWillUnmount() {
    if (navigator.platform.indexOf('Win') > -1) {
    }
  }
  componentDidUpdate(e) {
    // release notes text update, if the release notes page is visited, then
    // upon last visit date change, we need to update routes to update the link label updated
    // console.log('componentDidUpdate called.')

    let lastVisited = localStorage.getItem('releaseNoteLastVisitedDate');
    let currentPage = this.getBrandText(this.props.location.pathname);
    if (
      this.state.routesUpdatedOnce === false &&
      lastVisited !== this.state.releaseNotesLastVisitedDate &&
      !currentPage.toLocaleLowerCase().startsWith('release')
    ) {
      this.setState({ routes: getGuestRoutes(), routesUpdatedOnce: true });
    }

    if (e.history.action === 'PUSH') {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  // this function opens and closes the sidebar on small devices
  toggleSidebar = () => {
    document.documentElement.classList.toggle('nav-open');
    this.setState({ sidebarOpened: !this.state.sidebarOpened });
  };

  // TODO: Remove this function, when class component get refactored to functional component

  setCurrentCompany = (id) => {
    this.setState({ currentCompanyId: id });
  };

  getRoutes = (routes) => {
    let otherProps = {
      currentCompanyId: this.state.currentCompanyId,
    };
    return routes.map((prop, key) => {
      if (prop.layout === '/guest' || prop.layout === '/guest') {
        return (
          <Route
            path={prop.layout + prop.path}
            // component={prop.component}
            render={(routeProps) =>
              React.createElement(prop.component, { ...otherProps })
            }
            key={key}
          />
        );
      } else if (prop.layout === '/client' || prop.layout === '/client') {
        return (
          <Route
            path={prop.layout + prop.path}
            // component={prop.component}
            render={(routeProps) =>
              React.createElement(prop.component, { ...otherProps })
            }
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  handleBgClick = (color) => {
    this.setState({ backgroundColor: color });
  };

  getBrandText = (path) => {
    var guestRoutes = this.state.routes;
    for (let i = 0; i < guestRoutes.length; i++) {
      if (
        this.props.location.pathname.indexOf(
          guestRoutes[i].layout + guestRoutes[i].path,
        ) !== -1
      ) {
        return guestRoutes[i].name;
      }
    }
    return 'SP360';
  };
  render() {
    var guestRoutes = this.state.routes;
    var sideBarRoutes = guestRoutes.filter(
      (r) => !EXCLUDED_ROUTES.includes(r.name),
    );
    return (
      <>
        <div className="wrapper">
          <SidebarWrapper
            {...this.props}
            sidebarType="guest"
            routes={sideBarRoutes}
            setCurrentCompany={this.setCurrentCompany.bind(this)}
            bgColor={this.state.backgroundColor}
            logo={{
              outterLink:
                '/' +
                atob(localStorage.getItem(btoa('approle'))) +
                '/dashboard',
              text: '',
              imgSrc: logo,
            }}
            toggleSidebar={this.toggleSidebar}
          />
          <div
            className="main-panel"
            ref="mainPanel"
            data={this.state.backgroundColor}
          >
            <GuestNavbar
              {...this.props}
              brandText={this.getBrandText(this.props.location.pathname)}
              toggleSidebar={this.toggleSidebar}
              sidebarOpened={this.state.sidebarOpened}
            />
            <Switch>{this.getRoutes(guestRoutes)}</Switch>
            {this.props.location.pathname.indexOf('maps') !== -1 ? null : (
              <Footer fluid />
            )}
          </div>
        </div>
        <FixedPlugin
          bgColor={this.state.backgroundColor}
          handleBgClick={this.handleBgClick}
        />
      </>
    );
  }
}

export default Guest;
